import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Grid,
  Typography,
  Autocomplete,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import TablePagination from "@mui/material/TablePagination";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import moment from "moment";
import axios from "axios";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { FormatAmount } from "./FormatAmount";
import EmptyData from "../../StyledComponents/Table/EmptyData";
import { getRefrenceDataList } from "../Invoices/actions";

const useStyles = makeStyles(dashboardStyle);

const FormatDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = moment(dateString);
  const formattedDate = parsedDate.format("DD MMM YYYY");
  return formattedDate;
};

const defaultFormValues = {
  RowsOfPage: 25,
  PageNo: 1,
  venderName: "All",
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  statusFilter: { Status: "All" },
  PendingWith: "All",
  PhoneNumber: "All",
   invoice_Type: "",
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  isAsc: false,
};
const defaultFormValuesDownload = {
  venderName: undefined,
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  statusFilter: { Status: "All" },
   invoice_Type: "",
  PendingWith: undefined,
  PhoneNumber: undefined,
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  isAsc: false,
  isPdf: false,
};

const ReportTable = ({
  header,
  dropdownValue,
  loading,
  setData,
  setLoading,
  data,
  page,
}) => {
  console.log("dataList", data);
  const [invoiceNoFilter, setInvoiceNoFilter] = useState("");
  const [ReturedBy, setReturedBy] = useState("");
  const classes = useStyles();
  const [count, setCount] = useState(0);
  const [vendors, setVendors] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
const [multipleData, setMultipleData] = useState({
      invoice_Type: [],
    });

  const [formState, setFormState] = useState(
    defaultFormValues || defaultFormValuesDownload
  );

  const fetchData = async (params) => {
    setLoading(true);
    try {
      console.log("params", {
        pageNumber: formState?.PageNo,
        pageSize: 25,
        fromDate: params.startDate,
        toDate: params.endDate,
        vendorName: params?.Vendor?.Vendor_Name  === "All" ? undefined : params?.Vendor?.Vendor_Name,
        status: params.statusFilter?.Status === "All" ? undefined : params.statusFilter?.Status ,
        pendingWith:
          params.PhoneNumber === "All" ? undefined : params.PhoneNumber,
        sortColumn: params.sortColumn,
        sortDirection: params.sortDirection,
      });
      const res = await axios.get(
        `${process?.env?.REACT_APP_API_URL}/api/Report/GetInvoiceReceived`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
          params: {
            pageNumber: params?.PageNo || 1,
            pageSize: params?.RowsOfPage || 25,
            fromDate: params.startDate,
            vendorName:
            (params?.Vendor?.Vendor_Name === "All" ||    params?.Vendor?.Vendor_Name === "" )  ? undefined : params?.Vendor?.Vendor_Name,
            toDate: params.endDate,
            status:
            params.statusFilter?.Status  === "All" ? undefined : params.statusFilter?.Status ,
            pendingWith:
              params.PhoneNumber === "All" ? undefined : params.PhoneNumber || undefined,
            sortColumn: params.sortColumn,
            isAsc: params.isAsc,
            invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
          },
        }
      );
      console.log("res:", res);
      setData(res?.data?.response);
      setCount(res?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const handleDownloadFile = async (params, fileType) => {
    if (fileType === "pdf") {
      setIsPdfLoading(true);
    } else if (fileType === "excel") {
      setIsExcelLoading(true);
    }
    console.log("params", params?.venderName);
    try {
      console.log("params", {
        pageNumber: formState?.PageNo,
        pageSize: 25,
        fromDate: params.startDate,
        toDate: params.endDate,
        vendorName:
        params?.Vendor?.Vendor_Name=== "All" ? undefined : params?.Vendor?.Vendor_Name,
        status: params.statusFilter?.Status  === "All" ? undefined : params.statusFilter?.Status ,
        pendingWith:
          params.PhoneNumber === "All" ? undefined : params.PhoneNumber,
        invoiceNo: params.invoiceNoFilter?.trim() || "",      
        sortColumn: params.sortColumn,
        sortDirection: params.sortDirection,
      });
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/DownloadInvoiceRecievedPDFExcelFile`,
        {
          responseType: "blob",
          params: {
            fromDate: params?.startDate,
            vendorName:
            params?.Vendor?.Vendor_Name === "All" ? undefined : params?.Vendor?.Vendor_Name,
            toDate: params?.endDate,
            status:
              params.statusFilter?.Status === "All" ? undefined :   params.statusFilter?.Status,
            pendingWith:
              params.PhoneNumber === "All" ? undefined : params.PhoneNumber,
            sortColumn: params?.sortColumn,
            isAsc: params?.isAsc,
            invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
            isPdf: fileType === "pdf", // Set isPdf based on fileType
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      const blob = new Blob([response.data], {
        type:
          fileType === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileType === "pdf"
          ? `InvoiceReceiveFromVendor.pdf`
          : "InvoiceReceiveFromVendor.xlsx"
      );
      document.body.appendChild(link);
      link.click();
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    } catch (error) {
      console.error(`Error downloading ${fileType} file:`, error);
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    }
  };

  const resetFilter = async () => {
    setFormState(defaultFormValues);
    await fetchData(defaultFormValues);
  };
  const [listStatus, setListStatus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [returnList, setReturnList] = useState([]);

  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
        setter(response?.data); // Set the fetched data to the state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // fetchData(
    //   `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getStatusListGroup`,
    //   setListStatus
    // );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetPendingWithList`,
      setCategories
    );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetReturnByList`,
      setReturnList
    );
  }, []);
  console.log("latest", data);
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [userListPending, setUserListPending] = useState([]);
  const [searchQueryPending, setSearchQueryPending] = useState("");

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };
  useEffect(() => {
    if(formState?.Vendor?.Vendor_Name !== "" ){  
      fetchData(formState); 
    }
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState.sortColumn,
    formState.isAsc,
  ]);
  const handleSort = (index) => {
    if (index === formState.sortColumn) {
      setFormState((prevState) => ({
        ...prevState,
        isAsc: !prevState.isAsc,
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        sortColumn: index,
        isAsc: true,
      }));
    }
  };

    useEffect(() => {
        fetchData(formState);
      }, [
        formState?.PageNo,
        formState?.RowsOfPage,
        formState.sortColumn,
        formState.isAsc,
      ]);

  const handleDownloadExcel = () => {
    handleDownloadFile(formState, "excel");
  };

  const handleDownloadPDF = () => {
    handleDownloadFile(formState, "pdf");
  };
  const fetchUserList = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorDetails/${query ? query : null
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserList(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("PendingList", userListPending);
  const fetchUserListPending = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Authenticate/getUserDetails/${query ? query : "%20"
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserListPending(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("userList", userListPending)
  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
  };

  const handleSearchChangePending = (event, value) => {
    setSearchQueryPending(value);
  };

  useEffect(() => {
    if (searchQuery.trim() !== "") {
      fetchUserList(searchQuery);
    } else {
      fetchUserList();
    }
  }, [searchQuery]);
  useEffect(() => {
    if (searchQueryPending.trim() !== "") {
      fetchUserListPending(searchQueryPending);
    } else {
      fetchUserListPending();
    }
  }, [searchQueryPending]);
  const handleInvoiceClick = (RoleName, Invoice_Status, Invoice_Id, vendorCode) => {
    console.log("list Role", RoleName, Invoice_Status, Invoice_Id);
    const roleRoutes = {
      'Taxteam': 'taxteamdetail',
      'DeptCoordinator': 'departmentDetail',
      'IP': 'processInvoiceDetail',
      'IR': 'NewInvoiceDetail',
      'LoamApprover': 'LoamDetail',
      'I2P Initiator': 'NewInvoiceDetail',
      'Import': 'NewInvoiceDetail',
      'APSupervisor': 'APS_InvoiceDetailPage',
      'Reviewer': 'reviwerInvoiceDetail',
      'HR': 'NewInvoiceDetail',
      'EFDVInitiator': 'NewInvoiceDetail',
      'LineManager': 'LineManagerDetail',
      'SharedServices': 'SharedServicesDetail',
      'DirectorHR': 'DirectorHRDetail',
      'APManager': 'APS_InvoiceDetailPage',
      'APGM': 'APS_InvoiceDetailPage',
      'PRInitiator': 'NewInvoiceDetail',
      'Initiator': 'NewInvoiceDetail',
    };
    if (roleRoutes.hasOwnProperty(RoleName)) {
      window.open(`/#/${roleRoutes[RoleName]}?invoiceId=${Invoice_Id}&roleName=${RoleName}&status=${Invoice_Status}&vendorCode=${vendorCode}&edit=false`, "_blank");
    }
    else if (Invoice_Status === "PAID" || Invoice_Status === "Completed") {
      window.open(`/#/APS_InvoiceDetailPage?invoiceId=${Invoice_Id}&roleName=AP Supervisor&status=${Invoice_Status}&vendorCode=${vendorCode}&edit=false`, "_blank");
    }
    else {
      window.open(`/#/InvDetailPage?inv=${Invoice_Id}&vendorCode=${vendorCode}`, "_blank");
    }
  };
  const options = [

    ...listStatus.map(status => ({ Status: status?.StatusGroup }))
  ];

  
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    const updatedFormState = {
      ...formState,
      [name]: value,
    };

  };

   useEffect(() => {
      if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
        const vendorsStrigify = JSON.stringify(vendors);
        const vendorsParse = JSON.parse(vendorsStrigify);
        vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });
        setVendors(vendorsParse);
      }
    }, [vendors]);


      useEffect(() => {
        getVendorDetail(null, setVendors, setVendorLoading);
        getStatusList(null , setListStatus)
      
      }, []);

    const getVendorDetail = async (user, setUserData, setLoading) => {
      setLoading(true);
      //
      await axios({
        method: "get", //you can set what request you want to be
        url: `${
          process.env.REACT_APP_API_URL
        }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (res) => {
          setUserData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
    
          // setErrorMessage("Invalid username or password");
        });
    };

    
    const getStatusList = async (status , setListStatus) => {
      setLoading(true);
      //
      await axios({
        method: "get", //you can set what request you want to be
        url: `${
          process.env.REACT_APP_API_URL
        }/api/InvoiceDetails/getStatusListGroup?filter=${status ? status : ""}`,

        // `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getStatusListGroup`}
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (res) => {
          setListStatus(res.data);
               setLoading(false);
         
        })
        .catch((err) => {
          setLoading(false);
    
          // setErrorMessage("Invalid username or password");
        });
    };

      useEffect(()=>{
         getRefrenceDataList(
            "invoiceType",
            "invoice_Type",
            () => {},
            setMultipleData
          );
    
      },[])

  return (
    <div>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
            <span className={classes.asterisk}>*</span> Vendor:
          </Typography>
                        

<Autocomplete
                   
                    id="Vendor"
                    options={vendors}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Vendor"
                    value={formState.Vendor}
                    getOptionLabel={(option) =>
                      (option !== "" &&
                        `${
                          option?.Vendor_Code !== "-1"
                            ? `${option?.Vendor_Code}-`
                            : ""
                        }${option?.Vendor_Name}`) ||
                      ""
                    }
                    loading={vendorLoading}
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("Vendor", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getVendorDetail(
                            event.target.value,
                            setVendors,
                            setVendorLoading
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
            <span className={classes.asterisk}>*</span> Status:
          </Typography>
          {/* <Autocomplete
            disablePortal
            options={options}
            getOptionLabel={(option) => option.Status}
            size="small"
            value={
              formState.statusFilter === "All"
                ? { Status: "All" }
                : options.find((option) => option.Status === formState.statusFilter)
            }
            onChange={(e, newValue) => {
              const selectedStatus = newValue ? newValue.Status : null
              setFormState((prevState) => ({
                ...prevState,
                statusFilter: selectedStatus,
              }));
            }}
            renderInput={(params) => <TextField {...params}
            />}
          /> */}

          
<Autocomplete
                    // sx={{
                    //   "& .MuiInputBase-root": {
                    //     height: "30px",
                    //     textAlign: "center",
                    //     display: "flex",
                    //     alignItems: "center",
                    //   },
                    //   "& .MuiInputBase-input": {
                    //     marginTop: "-4px", // Adjust this value to move the text up
                    //     fontSize: 15,
                    //   },
                    // }}
                    id="statusFilter"
                    options={options}
                    getOptionLabel={(option) => option.Status}
                    classes={{ option: classes.option }}
                    size="small"
                    name="statusFilter"
                    value={
                      formState.statusFilter }
                   
                  
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("statusFilter", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getStatusList(
                            event.target.value,
                            setListStatus,
                          
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>

        {dropdownValue == "InvoiceType" ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={dropdownValue === "InvoiceStatus" ? 3 : 3}
          >
            <Typography>
              <span className={classes.asterisk}>*</span> Retured By:
            </Typography>
            <Autocomplete
              disablePortal
              options={returnList}
              getOptionLabel={(option) => option?.ReturnBy}
              size="small"
              value={
                listStatus.find((option) => option?.ReturnBy === ReturedBy) ||
                null
              }
              onChange={(e, newValue) => {
                setReturedBy(newValue?.ReturnBy);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={dropdownValue === "InvoiceStatus" ? 3 : 3}
          >
            <Typography>
              <span className={classes.asterisk}>*</span> Pending With:
            </Typography>
            <Autocomplete
              disablePortal
              options={[{ Name: "All" }, ...userListPending]}
              value={
                formState.PendingWith === "All"
                  ? { Name: "All" }
                  : userListPending.find(
                    (option) => option.Name === formState.PendingWith
                  ) || null
              }
              onChange={(e, newValue) => {
                const selectedPendingWith = newValue?.Name || null;
                setFormState((prevState) => ({
                  ...prevState,
                  PendingWith: selectedPendingWith,
                  PhoneNumber:
                    selectedPendingWith === "All"
                      ? undefined
                      : newValue?.PersonalNumber || "",
                }));
              }}
              getOptionLabel={(option) => option.Name}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  onChange={(e) => handleSearchChangePending(e, e.target.value)}
                />
              )} />
          </Grid>
        )}
        {dropdownValue == "InvoiceStatus" ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={dropdownValue === "InvoiceStatus" ? 3 : 3}
          >
            <Typography>
              <span className={classes.asterisk}>*</span> Invoice No :
            </Typography>
            <TextField
              variant="outlined"
              value={invoiceNoFilter}
              onChange={(e) => setInvoiceNoFilter(e.target.value)}
              fullWidth
              size="small"
            />
          </Grid>
        ) : null}
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ textAlign: "end" }}
        ></Grid>
      </Grid>
      <Grid container spacing={2} mt={0} mb={5}>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            <span className={classes.asterisk}>*</span> Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={formState.startDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                startDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            <span className={classes.asterisk}>*</span> End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={formState.endDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                endDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
        </Grid>

           <Grid   item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={3}>
                  <Typography style={{ color: "black" }}>
                                                 <span className={classes.asterisk}>*</span>
                                                 Invoice Type:
                                               </Typography>
                                               <Autocomplete
                                                
                                                 id="submitter_role"
                                                 options={
                                                   multipleData?.invoice_Type
                                                 }
                                                 size="small"
                                                 value={{
                                                   ReferenceCode: formState?.invoice_Type || "",
                                                 }}
                                                //  disabled={disable}
                                                 title="select select"
                                                 getOptionLabel={(option) =>
                                                   (option !== "" &&
                                                     `${option?.ReferenceCode}`) ||
                                                   ""
                                                 }
                                                 // loading={rolesLoading}
                                                 onChange={(event, newValue) => {
                                                  
                                                   autocompleteChangeHandler("invoice_Type" , newValue?.ReferenceCode);
                                                 }}
                                                 renderInput={(params) => (
                                                   <TextField
                                                     {...params}
                                                     type="text"
                                                     name=""
                                                     placeholder="Select a value"
                                                     required={formState?.isProceed}
                                                   />
                                                 )}
                                               />
                </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => fetchData(formState)}
              >
                Filter
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={resetFilter}
              >
                Reset Filter
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={handleDownloadExcel}
                disabled={isExcelLoading}
              >
                {isExcelLoading ? "Downloading.." : "Download Excel"}
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={handleDownloadPDF}
                disabled={isPdfLoading}
              >
                {isPdfLoading ? "Downloading.." : "PDF Download"}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <Table style={{ width: "100%" }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
            {header.map((header, index) => (
              <TableCell key={index} >
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "left",
                    cursor: "pointer",
                  }}
                >
                  {header.label}

                </div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              {[...Array(header.length)].map((header, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ) : data.length > 0 ? (
            data?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {header.map((header, colIndex) => (
                  <TableCell
                    key={colIndex}
                    align={header.key === "invoiceAmount" ? "right" : "left"}
                  >
                    {
                      header.key === "invoiceNo" ?
                        <div onClick={() => handleInvoiceClick(row?.role, row?.status, row?.invoice_ID, row?.vendorCode)} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>{row[header.key]}</div> :
                        header.key === "invoiceDate" ||
                          header.key === "submissionDate"
                          ? FormatDate(row[header.key]) // Format the date
                          : header.key === "invoiceAmount"
                            ? FormatAmount(row[header.key]) // Format the amount
                            : row[header.key]
                    }
                  </TableCell>
                ))}
              </TableRow>
            ))
          ):(
            <TableRow>
            <TableCell colSpan={10}><EmptyData/></TableCell>
          </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500, 1000]}
        component="div"
        count={count}
        rowsPerPage={formState.RowsOfPage}
        page={parseInt(formState.PageNo) - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default ReportTable;
